module.exports = __webpack_public_path__ + "img/tmara-logo.c6bda3ec.png";